export default {
    "Subtitles": "Sous-titres",
    "Please select a .vtt file": "Veuillez sélectionner un fichier .vtt",
    "Replace": "Remplacer",
    "Export subtitles": "Export des sous-titres",
    "Import subtitles": "Import des sous-titres",
    "Loading subtitles...": "Chargement des sous-titres...",
    "No subtitles for this file": "Aucun sous-titre pour ce fichier",
    "Add a language": "Ajouter une langue",
    "Add subtitles": "Ajouter des sous-titres",
    "Error adding subtitles": "Erreur lors de l'ajout des sous-titres",
    "Add": "Ajouter",
    "Delete": "Supprimer",
    "Cancel": "Annuler",
    "WebVTT (.vtt) files only. Other formats such as SRT are not supported.": "Fichiers WebVTT (.vtt) uniquement. Les autres formats comme le SRT ne sont pas pris en charge.",
    "Download": "Télécharger",
    "Import a .vtt file": "Importer un fichier .vtt",
    "Importing...": "Import en cours...",
    "Drop the .vtt file to replace these subtitles": "Déposez le fichier .vtt pour remplacer ces sous-titres",
    "{0} subtitles": "{0} sous-titres",
    "Empty": "Vide",
    "Subtitles imported ({0})": "Sous-titres importés ({0})",
    "Error uploading file: {0}": "Erreur lors de l'import du fichier : {0}",
    "Delete subtitles for this language?": "Supprimer les sous-titres de cette langue ?",
    "Error adding language": "Erreur lors de l'ajout de la langue",
    "Error deleting language": "Erreur lors de la suppression de la langue",
    "ace": "Acehnais",
    "af": "Afrikaans",
    "sq": "Albanais",
    "am": "Amharique",
    "ar": "Arabe",
    "an": "Aragonais",
    "hy": "Arménien",
    "as": "Assamais",
    "ay": "Aymara",
    "az": "Azerbaïdjanais",
    "ba": "Bachkir",
    "eu": "Basque",
    "be": "Biélorusse",
    "bn": "Bengali",
    "bho": "Bhojpuri",
    "bs": "Bosnien",
    "br": "Breton",
    "bg": "Bulgare",
    "yue": "Cantonais",
    "ca": "Catalan",
    "ceb": "Cebuano",
    "zh": "Chinois",
    "zh-hans": "Chinois (simplifié)",
    "zh-hant": "Chinois (traditionnel)",
    "hr": "Croate",
    "cs": "Tchèque",
    "da": "Danois",
    "prs": "Dari",
    "nl": "Néerlandais",
    "en": "Anglais",
    "en-gb": "Anglais (britannique)",
    "en-us": "Anglais (américain)",
    "eo": "Espéranto",
    "et": "Estonien",
    "fo": "Féroïen",
    "fi": "Finnois",
    "fr": "Français",
    "fr-ca": "Français (canadien)",
    "fr-fr": "Français (France)",
    "gl": "Galicien",
    "ka": "Géorgien",
    "de": "Allemand",
    "de-de": "Allemand (Allemagne)",
    "de-ch": "Allemand (suisse)",
    "el": "Grec",
    "gn": "Guarani",
    "gu": "Gujarati",
    "ht": "Créole haïtien",
    "ha": "Haoussa",
    "haw": "Hawaïen",
    "he": "Hébreu",
    "hi": "Hindi",
    "hu": "Hongrois",
    "is": "Islandais",
    "ig": "Igbo",
    "id": "Indonésien",
    "ga": "Irlandais",
    "it": "Italien",
    "ja": "Japonais",
    "jw": "Javanais",
    "jv": "Javanais",
    "kn": "Kannada",
    "pam": "Kapampangan",
    "kk": "Kazakh",
    "km": "Khmer",
    "gom": "Konkani",
    "ko": "Coréen",
    "ckb": "Kurde (sorani)",
    "kmr": "Kurde (kurmanji)",
    "ky": "Kirghize",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Letton",
    "ln": "Lingala",
    "lt": "Lituanien",
    "lmo": "Lombard",
    "lb": "Luxembourgeois",
    "mk": "Macédonien",
    "mg": "Malgache",
    "mai": "Maithili",
    "ms": "Malais",
    "ml": "Malayalam",
    "mt": "Maltais",
    "mi": "Maori",
    "mr": "Marathi",
    "mn": "Mongol",
    "my": "Birman",
    "ne": "Népalais",
    "no": "Norvégien",
    "nb": "Norvégien (bokmål)",
    "nn": "Nynorsk",
    "oc": "Occitan",
    "om": "Oromo",
    "pag": "Pangasinan",
    "ps": "Pachtoune",
    "fa": "Persan",
    "pl": "Polonais",
    "pt": "Portugais",
    "pt-br": "Portugais (brésilien)",
    "pt-pt": "Portugais (européen)",
    "pa": "Pendjabi",
    "qu": "Quechua",
    "ro": "Roumain",
    "ru": "Russe",
    "sa": "Sanskrit",
    "sr": "Serbe",
    "st": "Sotho du Sud",
    "sn": "Shona",
    "scn": "Sicilien",
    "sd": "Sindhi",
    "si": "Sinhala",
    "sk": "Slovaque",
    "sl": "Slovène",
    "so": "Somali",
    "es": "Espagnol",
    "es-419": "Espagnol (d'Amérique latine)",
    "su": "Soundanais",
    "sw": "Swahili",
    "sv": "Suédois",
    "tl": "Tagalog",
    "tg": "Tadjik",
    "ta": "Tamoul",
    "tt": "Tatar",
    "te": "Télougou",
    "th": "Thaï",
    "bo": "Tibétain",
    "ts": "Tsonga",
    "tn": "Tswana",
    "tr": "Turc",
    "tk": "Turkmène",
    "uk": "Ukrainien",
    "ur": "Ourdou",
    "uz": "Ouzbek",
    "vi": "Vietnamien",
    "cy": "Gallois",
    "wo": "Wolof",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "zu": "Zoulou"
}
